import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b54b83d8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=b54b83d8&prod&lang=sass"
import style1 from "./Footer.vue?vue&type=style&index=1&id=b54b83d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b83d8",
  null
  
)

export default component.exports